module.exports = __webpack_public_path__ + "img/border_Three_Circular_Cloud.3e69a93d.svg";